import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Route } from 'react-router-dom';

import './section.css';
import { urlJoin } from '../../utils/url-utils';
import {
    updateActivity,
    updateVideoData,
    uploadFile,
    submitTCC,
    initVideoData,
    updateModuleDates,
    clickInAttach,
} from './section.actions';
import CardList from './components/card-list';
import MiniCardList from './components/minicard-list';
import ItemList from './components/item-list';
import EmptyList from './components/empty-list';
import routes from '../../utils/routes';
import Spinner from '../spinner/spinner';
import { fetchClass } from '../app/app.actions';

const SectionOrCards = props => {
    const { match, cards = [], links, isActivity, history } = props;

    let card = {};
    if (cards.length > 0) {
        // eslint-disable-next-line
        card = cards.find(card => card.id == match.params.id);
        if (!card) {
            history.push(routes.HOME);
            card = {};
        }
    }
    const currentLinks = links.concat({ title: card.title, url: match.url });
    const allProps = {
        ...props,
        card,
        links: currentLinks,
        name: cards.indexOf(card),
        onClickItemAttach: props.clickInAttach,
    };
    if (card.cards && card.cards.length > 0) {
        return (
            <React.Fragment>
                {match.isExact && <CardList {...allProps}/>}
                <RecursiveContents {...allProps} parent={card}/>
            </React.Fragment>);
    } else if (card.minicards && card.minicards.length > 0) {
        allProps.isSubmitted = props.tccs[card.id] && props.tccs[card.id].submitted;
        allProps.firstModEnd = props.tccs[card.id] && props.tccs[card.id].firstModEnd;
        allProps.secondModEnd = props.tccs[card.id] && props.tccs[card.id].secondModEnd;
        return (
            <React.Fragment>
                {match.isExact && <MiniCardList {...allProps}/>}
                <RecursiveContents {...allProps} parent={card}/>
            </React.Fragment>);
    } else if (isActivity) {
        // ToDo: remove this hack once activities have an id
        card.items.forEach((item) => {
            item.items
                .forEach((subItem) => subItem.id = subItem.id || item.title);
        });
        return <ItemList {...allProps}/>;
    } else if (card.items && card.items.length > 0) {
        return <ItemList {...allProps}/>;
    } else {
        return <EmptyList {...allProps}/>;
    }
};

class Class extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            classId: '',
        };
    }

    componentDidMount() {
        const { idProp, match } = this.props;
        if (idProp === 'classId') {
            this.setState({ classId: match.params.id });
            this.props.fetchClass(match.params.id);
        }
    }

    componentWillReceiveProps(nextProps) {
        if ( nextProps.idProp && nextProps.match ) {
            if ( nextProps.idProp === 'classId' && nextProps.match.params.id !== this.state.classId ) {
                this.setState({ classId: nextProps.match.params.id }, () => {
                    this.props.fetchClass(nextProps.match.params.id);
                });
            }
        }
    }

    render() {
        const { match, links, parent: card, name } = this.props;
        const allProps = {
            ...this.props,
            card,
            links,
            name,
        };
        return (
            allProps.card.cards.length > 0
                ? <React.Fragment>
                    {match.isExact && <CardList {...allProps}/>}
                    <RecursiveContents {...allProps} parent={card}/>
                </React.Fragment>
                : <div style={{ height: '200px' }}>
                    <Spinner/>
                </div>
        );
    }
}

const RecursiveContents = ({ match, parent, links, classId = '', clickInAttach = () => null, ...rest }) => {
    return <Route
        path={urlJoin(match.url, ':id')}
        render={props => <SectionOrCards
            {...rest} {...props} isActivity={!!parent.minicards}
            cards={parent.cards || parent.minicards} links={links}
            name={parent.cards ? 'cards' : 'minicards'}
            clickInAttach={ clickInAttach }
            classId={ classId }
        />}
    />;
};

const mapStateToProps = ({ App, trainers, centers }, { match, classes, idProp, links = [], history }) => {
    let parent = {};
    if (classes && classes.length > 0) {
        // eslint-disable-next-line
        parent = classes.find(c => c[idProp] == match.params.id);
        if (!parent) {
            history.push(routes.HOME);
            parent = {};
        }
    }

    const classesNewEad = App.classesNewEad || [];
    const currentClassId = classesNewEad.find(e=>e.class_id === parent.classId);
    if (currentClassId) {
        if (!(currentClassId.tests) || currentClassId.tests.length === 0 ) {
            parent.cards = parent.cards.filter(e=>e.id !== 'online-test');
        }
    }

    const enrollment = App.student[parent[idProp]] || {};
    parent.cards = parent.cards || [];

    return {
        parent,
        name: parent[idProp],
        links: links.concat({ title: rootTitle(parent), url: match.url }),
        videosData: enrollment.videos || {},
        activities: enrollment.activities,
        pending: App.pending,
        tccs: enrollment.tccs || {},
        trainers: trainers,
        centers: centers,
        eadEndDate: App.student[match.params.id] ? App.student[match.params.id].eadEndDate : undefined,
        tccLoading: App.tccLoading,
        tccProgresses: App.tccProgresses || {},
        [idProp]: match.params.id,
    };
};

const mapDispatchToProps = (dispatch, { match }) => bindActionCreators({
    initVideoData: (...args) => initVideoData(match.params.id, ...args),
    updateVideoData: (...args) => updateVideoData(match.params.id, ...args),
    updateActivity: (...args) => updateActivity(match.params.id, ...args),
    updateModuleDates: (...args) => updateModuleDates(match.params.id, ...args),
    submitTCC: (...args) => submitTCC(match.params.id, ...args),
    uploadFile,
    fetchClass,
    clickInAttach,
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(Class);

const rootTitle = ({ courseId, className }) => className ? `${courseId} / ${className}` : courseId;



// WEBPACK FOOTER //
// ./src/components/section/section.js